import React from 'react';
import { getForms } from '../../actions/formActions';
import { applyIndicators } from '../../actions/stocksActions';
import { useDispatch, useSelector } from 'react-redux';
import SearchBoxWithListing from '../Common/SearchBoxWithListing';

const ApplyIndicators = (props) => {
    const searchBoxKey = "indicators_search_form";
    const listFormKey = "indicators_list_form";
    const dispatch = useDispatch();
    const stockState = useSelector((state) => state.stocks);
    const formState = useSelector((state) => state.forms);
    const { formJson = {} } = formState;
    const searchBoxJson = formJson[searchBoxKey] || {};
    const { indicatorsList = {} } = stockState;

    const listApi = (data) => {
        return dispatch(applyIndicators(data, listFormKey));
    }

    return (
        <div>
            <SearchBoxWithListing
                searchBoxKey={searchBoxKey}
                listFormKey={listFormKey}
                fetchForm={getForms}
                listApi={listApi}
                searchBoxJson={searchBoxJson}
                listingData={indicatorsList}
            />
        </div>

    )
}

export default ApplyIndicators;